import ApprovalIntegration from '../../ApprovalIntegration';
import styles from './styles.module.css';

export default function FloatingActionBar({
  variant = 'strategy',
  toolCallId = null,
  requiredArts = 0,
  onSideEffect = null,
  shifted = false,
}) {
  return (
    <div className={`${styles.floatingBar} ${shifted ? styles.floatingBarShifted : ''}`}>
      <ApprovalIntegration
        variant={variant}
        isReadOnly={false}
        toolCallId={toolCallId}
        requiredArts={requiredArts}
        onSideEffect={onSideEffect}
      />
    </div>
  );
}
